import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './Heading.module.css'

const headingLevels = [1, 2]

const Heading = ({ level, children, className, ...rest }) => {
  if (!headingLevels.includes(level)) {
    return children
  }

  const Tag = `h${level}`

  return (
    <Tag className={cx(styles[Tag], className)} {...rest}>
      {children}
    </Tag>
  )
}

Heading.propTypes = {
  /**
   * Level/Size of the heading. 1-6
   **/
  level: PropTypes.oneOf([1, 2])
}

Heading.defaultProps = {
  level: 1
}

export default Heading
